import React from 'react';

function FaqClassGroups(
  props: JSX.IntrinsicAttributes & React.SVGProps<SVGSVGElement>
): JSX.Element {
  return (
    <svg
      width={52}
      height={52}
      viewBox='0 0 52 52'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      {...props}
    >
      <rect width={52} height={52} rx={4} fill='#DFD8F3' />
      <mask
        id='mask0_9879_72210'
        style={{
          maskType: 'alpha'
        }}
        maskUnits='userSpaceOnUse'
        x={10}
        y={10}
        width={32}
        height={32}
      >
        <rect x={10} y={10} width={32} height={32} fill='#D9D9D9' />
      </mask>
      <g mask='url(#mask0_9879_72210)'>
        <path
          d='M11.9314 27.7372C12.2043 25.5164 14.086 23.6141 16.2985 23.3453H20.5622C20.5167 24.59 21.2942 25.7811 22.0509 26.6785C19.2388 27.4642 17.4481 30.1482 17.8203 33.5269C15.8022 33.4814 13.7924 32.9768 11.9272 32.3896V27.7372H11.9314Z'
          fill='#AF9DE0'
        />
        <path
          d='M32.8114 36.7835C28.7338 38.6073 23.643 38.231 19.582 36.8332V32.3792C19.582 30.204 21.6994 27.7516 24.5487 27.7516C24.7638 27.7516 27.7496 27.764 27.9481 27.764C30.996 27.764 32.8032 30.5431 32.8032 32.7184C32.8032 33.5289 32.8114 35.9689 32.8114 36.7835Z'
          fill='#AF9DE0'
        />
        <path
          d='M34.569 33.576C34.7054 30.1394 33.6385 27.8194 30.3342 26.678C31.2771 25.7517 31.8313 24.5731 31.7775 23.3407H35.1893C37.7161 23.3407 40.0733 25.4208 40.0733 28.1916L40.0485 32.3064C38.4233 33.2121 36.4093 33.4354 34.569 33.5719V33.576Z'
          fill='#AF9DE0'
        />
        <path
          d='M26.1864 26.2602C28.3333 26.2602 30.0738 24.5197 30.0738 22.3728C30.0738 20.2259 28.3333 18.4854 26.1864 18.4854C24.0395 18.4854 22.299 20.2259 22.299 22.3728C22.299 24.5197 24.0395 26.2602 26.1864 26.2602Z'
          fill='#AF9DE0'
        />
        <path
          d='M20.6202 21.2253C18.0934 22.6438 15.5211 21.2253 14.847 19.0955C14.1729 16.9658 15.3929 14.5093 17.8453 14.0833C20.5582 13.6119 22.5308 15.8326 22.4233 18.1485C21.4721 18.7895 20.7194 20.0095 20.6202 21.2253Z'
          fill='#AF9DE0'
        />
        <path
          d='M31.7778 21.487C31.6206 19.8079 30.5868 18.4639 29.5653 17.856C29.6687 14.7213 33.2376 12.8272 35.996 15.0108C38.7544 17.1943 36.8355 23.1536 31.7778 21.487Z'
          fill='#AF9DE0'
        />
      </g>
    </svg>
  );
}

FaqClassGroups.displayName = 'FaqClassGroups';

export default FaqClassGroups;
